import { Emojis } from 'constants/constants';
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from 'firebase/firestore';
import { ScheduledMatch } from 'types/Schedule.types';

export const matchToDoc = (match: ScheduledMatch): DocumentData => {
  console.log(`${Emojis.eyes} What is my date ${match.startingDate}`);

  return {
    homeTeamId: match.homeTeamId,
    homeTeamAbv: match.homeTeamAbv,
    homeTeamPoints: match.homeTeamPoints,
    awayTeamId: match.awayTeamId,
    awayTeamAbv: match.awayTeamAbv,
    awayTeamPoints: match.awayTeamPoints,
    timeRemaining: match.timeRemaining,
    matchId: match.matchId,
    startingDate: Timestamp.fromDate(new Date(match.startingDate)),
    matchStatus: match.matchStatus,
  };
};

export const scheduleConverter: FirestoreDataConverter<ScheduledMatch> = {
  toFirestore(match: ScheduledMatch): DocumentData {
    // return { ...gameToDoc(game), ...getModifiedInfo() };
    return matchToDoc(match);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): ScheduledMatch {
    const match = docSnap.data(options);

    return {
      homeTeamId: match.homeTeamId,
      homeTeamAbv: match.homeTeamAbv,
      homeTeamPoints: match.homeTeamPoints,
      awayTeamId: match.awayTeamId,
      awayTeamAbv: match.awayTeamAbv,
      awayTeamPoints: match.awayTeamPoints,
      timeRemaining: match.timeRemaining,
      matchId: match.matchId,
      startingDate: match.startingDate.toMillis(),
      matchStatus: match.matchStatus,
    };
  },
};
